import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import EnrollmentCreatePage from './enrollment-create'
import EnrollmentsListPage from './enrollment-list'
import EnrollmentUpdatePage from './enrollment-update'
import EnrollmentsValidatedListPage from './enrollment-validated-list'

const enrollmentsRoutes: Route[] = [
  {
    path: Paths.ENROLLMENT_LIST_PAGE,
    element: <EnrollmentsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.ENROLLMENT_CREATE_PAGE,
    element: <EnrollmentCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.ENROLLMENT_UPDATE_PAGE,
    element: <EnrollmentUpdatePage />
  },
  {
    path: Paths.ENROLLMENT_VALIDATED_LIST_PAGE,
    element: <EnrollmentsValidatedListPage />
  }
]

export default enrollmentsRoutes
